module.exports = __webpack_public_path__ + "build/desktop/img/logo-emirates.e9e9af13887c39f67c0ab87dc9d0352a.png";